import { useDispatch } from 'react-redux';
import { TextLink } from '@vds/buttons';
import { Body, Micro } from '@vds/typography';
import styled from 'styled-components';
import React from 'react';
import { Notification } from '@vds/notifications';
import { Tooltip } from '@vds/tooltips';
import parse from 'html-react-parser';
import * as actionTypes from '../../../pages/ProgressivePlans/@Redux/actionTypes';
import { eventDispatcher } from '../../common/Tagging';
import {
  getIntendType,
  addPlanOnSelectPlanSelection,
  isDesktopResolutionViewPort,
  getCookie,
  isVfNYEnable,
  getSession,
  setSession,
  isLoggedIn,
  getUrlName,
  getPlanPerkPromoBadge,
  isLteOnlyQualified,
  isJointTransactionFlow, 
  isECJointTransactionFlow,
  isEdgePhase1FFlag,
  isVHILiteQualified,
  isedgePerkBundleFFlag,
  isMiniCartFooterEnabled,
  isFLDiscountFFlag,
  renderHTML,
  isPlanPerkUIEnhancementFFlag,
  triggerScroll as scrollToElement,
} from '../../common/Helpers';
import { PROGRESSIVE, planJourneyCodes, INCLUDED_CHOICE_PROMO_TITLE, THUNDER_PLANS } from '../../../pages/Common/SessionValues/Constants';
import { checkIsMoversPlansPage } from '../../common/plansUtils';
import { getLqAddress } from '../../common/addressUtils';
import { getIsStreamlineMiniCartFFlag } from '../StreamLineOrder/helpers';


// additional check with pathname for sales flow only (not movers plan)
const isSalesFlow = checkIsMoversPlansPage?.() !== true && !window.location.pathname?.includes('movers');
const SubTitleWrapper = styled.p`
  font-size: 0.75rem;
  font-weight: 400;
  line-height: 1rem;
`;
const RequiredWrapper = styled.span`
  color: rgb(185, 83, 25);
`;

const FooterNoteMNH = styled.small`
  display: -webkit-box;
  white-space: normal;
  max-width: 270px;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  @media (min-width: 768px) {
    /* Desktop view: 2 lines */
    -webkit-line-clamp: 2;
  }
  @media (max-width: 767px) {
    /* Mobile view: 3 lines */
    -webkit-line-clamp: 3;
  }
  @media only screen and (max-width: 767px) {
    max-width: 70%;
  }
`;

// use flag for throttle for continue CTA and sales flow only (not movers plan)
export const showContinueCTAInFooter = () =>
  window.location.pathname?.includes('streamlineordering') || isMiniCartFooterEnabled() && window.location.pathname?.includes('progressiveplan') ||
  (isSalesFlow ? !!(getCookie('cdlThrottleList') && getCookie('cdlThrottleList')?.includes('FWA_Continue_CTA_Footer_T_Install')) : false);

const nbxFeedBackCall = (selectedPlanInfo, selectedPerks, storeDetails, dispatch) => {
  const lineActivity = `${getIntendType()}`;
  const { contextInfo } = storeDetails?.progressivePlans?.progressivePlanAPiResponse?.data || {};
  const lineLevelInfo = storeDetails?.progressivePlans?.progressivePlanAPiResponse?.data?.lineLevelPlans
    ? storeDetails?.progressivePlans?.progressivePlanAPiResponse?.data?.lineLevelPlans
    : {};
  const plans = (lineLevelInfo && lineLevelInfo?.lines?.length > 0 && lineLevelInfo?.lines[0]?.products[0]?.plans) || [];
  const availablePerks = lineLevelInfo?.lines?.[0]?.availablePerks ?? [];
  const { staticContent } = storeDetails?.plansReferenceData?.output || {};
  const { getfwaplansLoaded } = storeDetails?.progressivePlans || {};
  if (
    getfwaplansLoaded &&
    (selectedPlanInfo ||
      (plans?.length > 0 && selectedPlanInfo?.selectedPlan?.length > 0) ||
      (selectedPerks?.length > 0 && availablePerks?.length > 0))
  ) {
    const selectedPlan = plans?.filter((el) => selectedPlanInfo?.selectedPlan?.planId === el.planId);
    const selectedPerkList = availablePerks?.filter((el) => selectedPerks?.some((f) => f.spoId === el.spoId));
    const selectedPlanPerkList = selectedPlanInfo ? [...selectedPlan, ...selectedPerkList] : selectedPerkList;
    const feedBackTile =
      selectedPlanPerkList &&
      selectedPlanPerkList?.length > 0 &&
      selectedPlanPerkList.map((item) => {
        const isPlan = item?.planId;
        return {
          ...item,
          tacticLocation: isPlan ? 'AvailablePlans' : 'AvailablePerks',
        };
      });
    dispatch({
      type: actionTypes.FEEDBACK_API,
      feedBackTile,
      mtn: 'newLine1',
      dispositionOptionId: 81,
      lineActivityType: lineActivity,
      selectedLLP: '',
      feedbackContextInfo: staticContent?.feedbackContextInfo,
      nbxSessionId: contextInfo?.sessionId,
    });
  }
};
export const getStreamlineResumeCartThrottleFlag = (storeDetails) => {
  const featureFlags = storeDetails?.progressivePlans?.progressivePlanAPiResponse?.data?.featureFlags;
  return featureFlags?.streamlineResumeCartThrottleFFlag || false;
};
export const getPerkPriceDiscountFFlag = (storeDetails) => {
  const featureFlags = storeDetails?.progressivePlans?.progressivePlanAPiResponse?.data?.featureFlags;
  return featureFlags?.perkPriceDiscountFFlag || false;
};
// dispatch action for add plan API
const dispatchAddPlanAPI = (planSelectionJourney, history, dispatch, storeDetails) => {
  const isstreamlineMinicartNSEFFlag = getIsStreamlineMiniCartFFlag(storeDetails?.progressivePlans?.progressivePlanAPiResponse?.data?.featureFlags);
  const journeyCode = planSelectionJourney === PROGRESSIVE ? planJourneyCodes.PROGRESSIVE : planJourneyCodes.POPULAR_CUSTOMIZED;
  const addPlanOnSelectPlanSelectionKey = isstreamlineMinicartNSEFFlag || addPlanOnSelectPlanSelection();
  const streamlineResumeCartThrottleFFlag = getStreamlineResumeCartThrottleFlag(storeDetails);
  dispatch({
    type: actionTypes.ADD_PLAN_API,
    payload: 'progressivePlan',
    history,
    planSelectionJourney: journeyCode,
    addPlanOnSelectPlanSelectionKey,
    streamlineResumeCartThrottleFFlag,
    isstreamlineMinicartNSEFFlag,
  });
};

export const getCTAText = (isPerksSelected) => {
  const isPerksSelectedFlag = isPerksSelected ? 'Continue' : 'Continue without perks';
  const pathName = window?.location?.pathname;
  if (isPlanPerkUIEnhancementFFlag() && pathName?.includes('progressiveplan')) {
    return 'Continue';
  }
  if (pathName?.includes('progressiveplan')) {
    return isPerksSelectedFlag;
  }
  return 'Continue';
};

export const bauHandleContinueClick = (
  selectedPlanInfo,
  selectedPerks,
  storeDetails,
  dispatch,
  isfwaUpSellModalFFlag,
  planSelectionJourney,
  history,
) => {
  const { staticContent } = storeDetails?.plansReferenceData?.output || {};
  const isChoiceOffer = selectedPlanInfo?.selectedPlan?.availablePromotions?.some((promo) => promo.choiceOffer === true);
  if (isChoiceOffer && !selectedPlanInfo?.selectedPlan?.selectedSpecialPromo) {
    dispatch({ type: actionTypes.UPDATE_SPECIAL_OFFER_PLAN, response: true });
    dispatch({ type: actionTypes.SPECIAL_GIFTSECTION_NOTIFICATION, value: true });
    return null;
  }
  if (staticContent?.FeedbackApiFlag) {
    nbxFeedBackCall(selectedPlanInfo, selectedPerks, storeDetails, dispatch);
  }
  dispatchAddPlanAPI(planSelectionJourney, history, dispatch, storeDetails);
  resetContinueCTAStyle();
  clearAbandonedCart(dispatch, isfwaUpSellModalFFlag);
  dispatch({ type: actionTypes.SET_VHDP_MODAL, value: false });
};

export const hasHomeDeviceSupportPerk = (data) =>
  Array.isArray(data) &&
  data.some(
    (item) =>
      typeof item.perkTitle === 'string' && item.perkTitle.trim().toLowerCase() === 'verizon home device protect' || String(item.spoId) === '3223',
  );

// Constants for VHDP eligible plan names
const VHDP_ELIGIBLE_PLANS = new Set(['LTE HOME PLUS', '5G HOME ULTIMATE']);

// Helper function to check if plan is eligible for VHDP
export const isVhdpEligiblePlan = (planDisplayName) => planDisplayName && VHDP_ELIGIBLE_PLANS.has(planDisplayName.toUpperCase());

// Helper function to check if VHDP is enabled
export const isVhdpEnabled = (storeDetails) => {
  const {
    fwaUpSellModalAALFFlag = false,
    fwaUpSellModalNSEFFlag = false,
    isVhdpEligibleFFlag = false,
    saveTheSaleThunderForPlansPageFFlag = false,
  } = storeDetails?.progressivePlans?.progressivePlanAPiResponse?.data?.featureFlags;
  const isfwaUpSellModalFFlag = isLoggedIn() ? fwaUpSellModalAALFFlag : fwaUpSellModalNSEFFlag;
  return (isVhdpEligibleFFlag && !isfwaUpSellModalFFlag && !saveTheSaleThunderForPlansPageFFlag) || getCookie('isVHDP') === 'Y';
};

export const handleContinueClick = (
  selectedPlanInfo,
  selectedPerks,
  storeDetails,
  dispatch,
  isfwaUpSellModalFFlag,
  planSelectionJourney,
  history,
) => {
  const shouldShowVhdpModal =
    isVhdpEnabled(storeDetails) &&
    isVhdpEligiblePlan(selectedPlanInfo?.selectedPlan?.displayName) &&
    !hasHomeDeviceSupportPerk(selectedPlanInfo?.selectedPerks) &&
    window.location.pathname?.includes('progressiveplan');
  const isChoiceOffer = selectedPlanInfo?.selectedPlan?.availablePromotions?.some((promo) => promo.choiceOffer === true);
  if (isChoiceOffer && (!selectedPlanInfo?.selectedPlan?.selectedSpecialPromo || Object.keys(selectedPlanInfo?.selectedPlan?.selectedSpecialPromo).length === 0)) {
    dispatch({ type: actionTypes.UPDATE_SPECIAL_OFFER_PLAN, response: true });
    dispatch({ type: actionTypes.SPECIAL_GIFTSECTION_NOTIFICATION, value: true });
    dispatch({ type: actionTypes.UPDATE_PLANS_ACCORD_STATUS, response: true });
    scrollToElement(actionTypes.SPECIAL_GIFT_NOTIFICATION_ID);
    return null;
  }
  if (shouldShowVhdpModal) {
    dispatch({ type: actionTypes.SET_VHDP_MODAL, value: true });
  } else {
    bauHandleContinueClick(selectedPlanInfo, selectedPerks, storeDetails, dispatch, isfwaUpSellModalFFlag, planSelectionJourney, history);
  }
};

const getContinueCTAId = () => {
  const handlePathNameCheck = window.location.pathname?.includes('progressiveplan');
  return handlePathNameCheck ? 'continueCTAFooterId' : '';
};

export const getThunderEmberNotification = (thunderNotificationProps) => {
  const {
    getPerkOnTitle,
    perkStaticContent,
    actionTypes: actions,
    plansAccordianContainerId,
    dispatch,
    triggerScroll,
    linkClickTagging,
    selectedPlan,
    isEntryThunderPlan,
    isPremiumThunderPlan,
    hasBayouPerkOnAccount,
  } = thunderNotificationProps;
  let notification = {};
  if (isEntryThunderPlan) {
    notification = {
      type: 'info',
      title: getPerkOnTitle,
      disableFocus: true,
      subtitle: perkStaticContent?.getPerkOnSubTitleThunder,
      buttonData: [
        {
          children: perkStaticContent?.exploreButtonText,
          'data-testid': 'explorePlanBtn',
          onClick: () => {
            dispatch({ type: actions?.UPDATE_PLANS_ACCORD_STATUS, response: true });
            triggerScroll(plansAccordianContainerId);
            linkClickTagging({ buttonText: perkStaticContent?.exploreButtonText });
          },
        },
      ],
    }
  } else if (isPremiumThunderPlan && !hasBayouPerkOnAccount) {
    notification = {
      type: 'success',
      title: perkStaticContent?.claimPerkTitle,
      hideCloseButton: true,
      subtitle: (
        <div>
          {perkStaticContent?.claimPerkOnSubTitleThunder?.replace('#planName#', selectedPlan?.displayName)}
          <br />
          <br />
          <span>{perkStaticContent?.claimPerkOnSubTitle2}</span>
        </div>
      ),
    };
  } else if (isPremiumThunderPlan && hasBayouPerkOnAccount) {
    notification = {
      type: 'success',
      hideCloseButton: true,
      title: perkStaticContent?.qualityPerkTitle,
      subtitle: perkStaticContent?.qualityPerkSubTitle,
    };
  }
  return notification;
};

const isPremiumPlan = (planName) => planName === "5G HOME ULTIMATE";
export const perkPromoPriceDisc = (perkDetails, selectedPlanInfo, storeDetails, planPerkPrice) => {
  const perkPriceDiscountFFlag = getPerkPriceDiscountFFlag(storeDetails);
  if (!perkPriceDiscountFFlag) {
    return planPerkPrice;
  }
  const planData = storeDetails?.progressivePlans?.progressivePlanAPiResponse;
  const selectedPlan = selectedPlanInfo?.selectedPlan;
  const spoId = perkDetails?.spoId;
  const discountedPrice = typeof perkDetails?.discountedPrice === 'number' ? perkDetails.discountedPrice : 0;
  if (!planData || !selectedPlan || !spoId || !discountedPrice) {
    return planPerkPrice;
  }
  const perkEyebrow = getPlanPerkPromoBadge(planData, selectedPlan, spoId, 'PERK-EYEBROW');
  if (perkEyebrow?.badgeText?.includes('Your special gift')) {
    return planPerkPrice - discountedPrice;
  }
  return planPerkPrice;
};

export const GetFooter = (selectedPlanInfo, planSelected, selectedPerks, history, storeDetails, isfwaUpSellModalFFlag, perksSelecetd) => {
  const hasPerkOnUsAccount = storeDetails?.progressivePlans?.progressivePlanAPiResponse?.data?.hasPerkOnUsAccount;
  const hasMobileLine = storeDetails?.progressivePlans?.progressivePlanAPiResponse?.data?.hasMobileLine;
  const { perkStaticContent } = storeDetails?.plansReferenceData?.output || {};
  const customerType = storeDetails?.progressivePlans?.progressivePlanAPiResponse?.data?.customerType;
  const ineligibleCust = customerType === 'ME' || customerType === 'SL';
  let helperTextMH = false;
  let planPerkPrice = 0;
  let savingsPrice = 0;
  planPerkPrice += selectedPlanInfo?.selectedPlan?.discPriceWOAutoPay || 0;
  const priceCusPlan = (element) => {
    planPerkPrice += Number(element?.discountedPrice || 0);
    savingsPrice += Number(element?.totalAmountOff || 0);
    savingsPrice = Number(savingsPrice.toFixed(2));
    planPerkPrice = perkPromoPriceDisc(element, selectedPlanInfo, storeDetails, planPerkPrice);
  };
  if (Array.isArray(selectedPlanInfo?.selectedPerks)) {
    selectedPlanInfo.selectedPerks.forEach((element, index) => {
      const currentPerk = selectedPlanInfo?.selectedPerks[selectedPlanInfo?.selectedPerks.length - 1];
      const isHDSPPerk = currentPerk.spoId === '3222' || currentPerk.spoId === '3223';
      if (
        !isHDSPPerk &&
        (selectedPlanInfo?.selectedPlan?.displayName?.toUpperCase() === 'LTE HOME PLUS' || isPremiumPlan(selectedPlanInfo?.selectedPlan?.displayName?.toUpperCase())) &&
        !hasPerkOnUsAccount &&
        hasMobileLine &&
        !ineligibleCust
      ) {
        if (index === 0) {
          helperTextMH = true;
          planPerkPrice += Number(element?.discountedPrice || 0);
          planPerkPrice -= 10;
        } else {
          planPerkPrice += Number(element?.discountedPrice || 0);
          planPerkPrice = perkPromoPriceDisc(element, selectedPlanInfo, storeDetails, planPerkPrice);
        }
      } else {
        priceCusPlan(element);
      }
    });
  }
  const dispatch = useDispatch();
  const savingsObj = (price) => ({
    savings: {
      price,
      superscript: '*',
      trailingText: { children: 'savings' },
    },
  });
  const { SessionValues: { planSelectionJourney } = {} } = storeDetails || {};
  const savingsText = savingsPrice !== 0 ? `with ${savingsPrice}$ savings per month` : '';

  const enableChoiceOffer = storeDetails?.progressivePlans?.enableChoiceOffer;
  const MNHFooterNotefunc = () => (
    <FooterNoteMNH style={{ color: '#6F7171', fontSize: '11px', lineHeight: '16px', letterSpacing: '0.8px' }}>
      {perkStaticContent.MNHFooterNote}
    </FooterNoteMNH>
  );
  const footerPerksTerms = () => showContinueCTAInFooter() && isedgePerkBundleFFlag() && GetActionSubtitle(perksSelecetd, selectedPerks);
  const footerLayoutType = () => (isedgePerkBundleFFlag() ? 'inline' : 'stacked');
  return {
    total: {
      title: {
        children: (
          <div style={{ margin: '0', padding: '0' }}>
            Plan Total
            {helperTextMH && <MNHFooterNotefunc />}
          </div>
        ),
      },
      price: {
        price: planPerkPrice?.toFixed(2),
        superscript: '*',
      },
      ...(savingsPrice !== 0 && savingsObj(savingsPrice)),
      ariaLabel: `Plan total ${planPerkPrice}$ per month ${savingsText}`,
    },
    // show button when a plan selected
    button: planSelected &&
      showContinueCTAInFooter() && {
        use: 'primary',
        children: getCTAText(perksSelecetd),
        id: getContinueCTAId(),
        disabled: isDisabled(selectedPlanInfo, enableChoiceOffer, storeDetails),
        onClick: () => {
          handleContinueClick(selectedPlanInfo, selectedPerks, storeDetails, dispatch, isfwaUpSellModalFFlag, planSelectionJourney, history);
        },
        'data-track':
          showContinueCTAInFooter() &&
          `{"type":"link","name":${getCTAText(perksSelecetd)},"data":{"page":{"throttle":"nsa version|vhi|ec y|co y"},"target":{"sandBox":"FWA_Continue_CTA_Footer_T_Install"}}}`,
      },
    // T&C in footer
    helperText: footerPerksTerms(),
    layout: footerLayoutType(),
  };
};

export const isDisabled = (selectedPlanInfo, enableChoiceOffer, storeDetails) => {
  const hasAvailablePromotions = selectedPlanInfo?.selectedPlan?.availablePromotions?.length;
  const isSpecialOfferEnabled = isSpecialOfferSectionEnable(selectedPlanInfo?.selectedPlan?.availablePromotions);
  const isStreamlineOrdering = window.location.pathname?.includes('streamlineordering');
  const hasSelectedSpecialPromo = selectedPlanInfo?.selectedPlan?.selectedSpecialPromo?.sedOfferId;
  const plansContinuefwaFFlag = storeDetails?.progressivePlans?.progressivePlanAPiResponse?.data?.featureFlags?.plansContinuefwaFFlag || false;
  if (plansContinuefwaFFlag) {
    return false;
  }
  return hasAvailablePromotions && enableChoiceOffer && isSpecialOfferEnabled && !isStreamlineOrdering ? !hasSelectedSpecialPromo : false;
};


// reset continue CTA style for other pages after click
export const resetContinueCTAStyle = () => {
  const elementRef = document.getElementById('chatbotStartBar');
  if (elementRef && isDesktopResolutionViewPort()) {
    elementRef.style.setProperty('margin-bottom', '0px', 'important');
    elementRef.style.transition = 'height 0.25s ease-out';
  }
};

export const getPricingDetails = () => ({
  title: {
    children: 'Your plan details',
  },
  lists: [
    {
      title: {
        children: 'Your unlimited data',
      },
      hideLine: false,
      data: [
        {
          label: {
            children: 'Unlimited Ultimate',
          },
          firstPrice: {
            price: '55',
          },
          secondPrice: {
            price: '4.99',
            leadingText: {
              children: 'Save',
            },
          },
        },
      ],
    },
    {
      title: {
        children: 'Your perks',
      },
      hideLine: false,
      data: [
        {
          label: {
            children: 'Disney Bundle',
          },
          firstPrice: {
            price: '10',
          },
          secondPrice: {
            price: '4.99',
            leadingText: {
              children: 'Save',
            },
          },
        },
        {
          label: {
            children: 'Netflix and Max (with ads)',
          },
          firstPrice: {
            price: '10',
          },
          secondPrice: {
            price: '4.99',
            leadingText: {
              children: 'Save',
            },
          },
        },
      ],
    },
    {
      hideLine: false,
      data: [
        {
          size: 'medium',
          label: {
            children: 'Plan Total',
          },
          firstPrice: {
            price: '75',
          },
        },
        {
          label: {
            children: 'Total Savings',
          },
          firstPrice: {
            price: '9.98',
            color: 'green',
            leadingText: {
              children: '-',
            },
          },
        },
      ],
    },
  ],
});

const RenderTextLink = (selectedPerks) => {
  const dispatch = useDispatch();
  const selectedPerksTerms = Array.isArray(selectedPerks) && selectedPerks?.map((perk) => perk?.spoId);
  return (
    <>
      By continuing, you agree to perk{' '}
      <TextLink
        data-testId="terms-and-conditions"
        data-track='{"type": "link","name": "perks tnc"}'
        onClick={() => {
          dispatch({ type: actionTypes.SET_TERMS_AND_CONDITIONS_OVERLAY, response: { selectedPerksTerms, show: true } });
        }}
      >
        Terms & Conditions
      </TextLink>
      .
    </>
  );
};

// continue CTA with perks
export const getNetworkBandwidthType = () => {
  let LQResponseData = getSession('LQResponse');
  if (LQResponseData) {
    LQResponseData = JSON.parse(LQResponseData);
  }
  return LQResponseData?.output?.networkBandwidthType;
};
export const getSpoid = (networkBandwidthType) => {
  const spoidNew = networkBandwidthType === 'cbd' || networkBandwidthType === 'lte' ? '3327' : 'no orderid';
  return networkBandwidthType === 'mmw' || networkBandwidthType === 'mmwave' ? '3325' : spoidNew;
};

export const handleOnClick = ({
  planSelected,
  selectedPlanInfo,
  staticContent,
  selectedPerks,
  storeDetails,
  dispatch,
  planSelectionJourney,
  history,
  isVfny,
  spoid,
  isfwaUpSellModalFFlag,
  plansContinuefwaFFlag,
}) => {
  if (!planSelected) {
    eventDispatcher('notify', { name: 'Please select your plan to continue' });
    eventDispatcher('openView', { name: 'message displayed' });
    dispatch({ type: actionTypes.UPDATE_ERROR_NOTIFICATION, payload: true });
    return;
  }
  const isChoiceOffer = selectedPlanInfo?.selectedPlan?.availablePromotions?.some((promo) => promo.choiceOffer === true);
  if (plansContinuefwaFFlag && isChoiceOffer && (!selectedPlanInfo?.selectedPlan?.selectedSpecialPromo || Object.keys(selectedPlanInfo?.selectedPlan?.selectedSpecialPromo).length === 0)) {
    dispatch({ type: actionTypes.SPECIAL_GIFTSECTION_NOTIFICATION, value: true });
    return;
  }

  if (staticContent?.FeedbackApiFlag) {
    nbxFeedBackCall(selectedPlanInfo, selectedPerks, storeDetails, dispatch);
  }

  dispatchAddPlanAPI(planSelectionJourney, history, dispatch, storeDetails);

  if (isVfny) {
    eventDispatcher('sendData', {
      name: '',
      svars: {
        evar28: `${spoid} - VERIZON FORWARD - NY`,
      },
    });
  }
  clearAbandonedCart(dispatch, isfwaUpSellModalFFlag);
};

export const GetAction = (planSelected, perksSelecetd, selectedPerks, history, storeDetails, isfwaUpSellModalFFlag = false) => {
  const dispatch = useDispatch();
  const { SessionValues: { planSelectionJourney } = {} } = storeDetails || {};
  const { staticContent } = storeDetails?.plansReferenceData?.output || {};
  const selectedPlanInfo = storeDetails?.progressivePlans?.selectedPlanInfo || {};
  const lqAddress = getLqAddress();
  const { state = '' } = lqAddress || {};
  const isVfny = isVfNYEnable() && state === 'NY';
  const networkBandwidthType = getNetworkBandwidthType();
  const spoid = getSpoid(networkBandwidthType);
  const enableChoiceOffer = storeDetails?.progressivePlans?.enableChoiceOffer;
  const plansContinuefwaFFlag = storeDetails?.progressivePlans?.progressivePlanAPiResponse?.data?.featureFlags?.plansContinuefwaFFlag || false;
  if (isSalesFlow) {
    return {
      helperText: {
        children: perksSelecetd && !showContinueCTAInFooter() ? RenderTextLink(selectedPerks) : <></>,
      },
      buttonGroup: !showContinueCTAInFooter() && {
        data: [
          {
            use: 'primary',
            children: 'Continue',
            disabled: isDisabled(selectedPlanInfo, enableChoiceOffer, storeDetails),
            onClick: () =>
              handleOnClick({
                planSelected,
                selectedPlanInfo,
                staticContent,
                selectedPerks,
                storeDetails,
                dispatch,
                planSelectionJourney,
                history,
                isVfny,
                spoid,
                isfwaUpSellModalFFlag,
                plansContinuefwaFFlag,
              }),
          },
        ],
      },
    };
  }
};

export const GetActionSubtitle = (perksSelecetd, selectedPerks) => {
  if (isSalesFlow) {
    return {
      children: perksSelecetd ? RenderTextLink(selectedPerks) : <></>,
      size: 'small',
      color: 'rgb(0, 0, 0)',
    };
  }
};

export const GetNotification = () => {
  const dispatch = useDispatch();
  return {
    type: 'error',
    title: 'Please select plan to continue',
    layout: 'vertical',
    hideCloseButton: true,
    buttonData: [
      {
        use: 'secondary',
        children: 'Select plan',
        onClick: () => {
          dispatch({ type: actionTypes.UPDATE_PLANS_ACCORD_STATUS, response: true });
          const elem = document.getElementById('main-plan-accordion');
          if (elem) {
            elem.scrollIntoView({ behavior: 'smooth' });
          }
        },
      },
    ],
  };
};
export const fetchMHDiscounts = (item, storeDetails) => {
  const price = item?.price?.promos?.find((promo) => promo?.promoDescription?.includes('MOBILE + HOME DISCOUNT'))?.amountOff;
  const displayplanName = item?.displayName;
  const eligibleDiscount = storeDetails?.progressivePlans?.progressivePlanAPiResponse?.data?.availablePromotions || [];
  const isMHDiscountsApplied = eligibleDiscount?.includes('MHDiscount');
  if (isMHDiscountsApplied && (displayplanName?.toUpperCase() === '5G HOME' || displayplanName?.toUpperCase() === 'LTE HOME')) {
      if (String(price) === '5') {
        return 'MHBasic';
      }
      return 'MHPremium';
  }
  if (
    isMHDiscountsApplied &&
    (displayplanName?.toUpperCase() === '5G HOME PLUS' ||
      displayplanName?.toUpperCase() === 'LTE HOME PLUS' ||
      displayplanName?.toUpperCase() === '5G HOME ULTIMATE')
  ) {
      if (String(price) === '15') {
        return 'MHBasic';
      }
      return 'MHPremium';
  }
};

const getTooltipContentByPlanType = (planName, propositionName, featureData) => {
  if (planName === '5G HOME' || planName === 'LTE HOME' || planName === '5G HOME PLUS') {
    return `${featureData?.emberMHNonPremiumTooltip}<br><br>${featureData?.emberAutopayTooltip}`;
  }
  if (planName === '5G HOME ULTIMATE' || planName === 'LTE HOME PLUS' || propositionName === '5G HOME ULTIMATE' || propositionName === 'LTE HOME PLUS') {
    return `${featureData?.emberMHTooltip}<br><br>${featureData?.emberAutopayTooltip}`;
  }
  return null;
};

const getJointTransactionTooltipContent = ({ planName, propositionName, featureData, obj, promotionConstants }) => {
  if ((isJointTransactionFlow() || isECJointTransactionFlow()) && !obj?.[promotionConstants.Autopay]) {
    return getTooltipContentByPlanType(planName, propositionName, featureData);
  }
  if ((isJointTransactionFlow() || isECJointTransactionFlow()) && obj?.[promotionConstants.Autopay]) {
    return planName === '5G HOME' || planName === 'LTE HOME' || planName === '5G HOME PLUS'
      ? `${featureData?.emberMHNonPremiumTooltip}`
      : `${featureData?.emberMHTooltip}`;
  }
  return null;
};

const getThunderTooltipContent = ({
  tooltipInfo,
  planName,
  propositionName,
  eligibleDiscounts,
  featureData,
  obj,
  promotionConstants,
  isMHDiscountsApplied,
  item,
}) => {
  
  const planId = item?.planId || item?.pricePlanId;
  const thunderPlanCheck = (planIds) => THUNDER_PLANS.includes(planIds);
    let tooltipContent = tooltipInfo;
    if (thunderPlanCheck(planId)) {
      const jointTransactionTooltip = getJointTransactionTooltipContent({ planName, propositionName, featureData, obj, promotionConstants });
      if (jointTransactionTooltip) {
        tooltipContent = jointTransactionTooltip;
      }
      else if (!eligibleDiscounts || (eligibleDiscounts && eligibleDiscounts?.length === 0)) {
        tooltipContent = getTooltipContentByPlanType(planName, propositionName, featureData);
      } else if (obj?.[promotionConstants.Autopay] && !isMHDiscountsApplied) {
        tooltipContent =
          planName === '5G HOME' || planName === 'LTE HOME' || planName === '5G HOME PLUS'
            ? `${featureData?.emberMHNonPremiumTooltip}`
            : `${featureData?.emberMHTooltip}`;
      } else if (!obj?.[promotionConstants.Autopay] && isMHDiscountsApplied) {
        tooltipContent = `${featureData?.toolTipHeading}${featureData?.emberAutopayTooltip}`;
      }
    }
    return tooltipContent;
    };

const getAutopayMHDiscountTooltip = ({
  obj,
  promotionConstants,
  isMHDiscountsApplied,
  planName,
  featureData,
  displayName,
}) => {
  if (obj?.[promotionConstants.Autopay] && !isMHDiscountsApplied) {
    return planName === '5G HOME' || planName === 'LTE HOME'
      ? `${featureData?.emberMHNonPremiumTooltip}`
      : `${featureData?.emberMHTooltip}`?.replace('#planName#', displayName);
  }
  if (!obj?.[promotionConstants.Autopay] && isMHDiscountsApplied) {
    return `${featureData?.toolTipHeading}${featureData?.emberAutopayTooltip}`;
  }
  return undefined;
};

const getTooltipContentByDiscounts = ({
  eligibleDiscounts,
  obj,
  promotionConstants,
  featureData,
}) => {
  let tooltipContents;
  if (!eligibleDiscounts || (eligibleDiscounts && eligibleDiscounts?.length === 0)) {
    tooltipContents = featureData?.lowPriceTooltip;
  }
  // if only autopay is there, showing premium disc only
  else if (obj?.[promotionConstants.Autopay] && !obj?.[promotionConstants.MHPremium] && !obj?.[promotionConstants.MHBasic]) {
    tooltipContents = `${featureData?.toolTipHeading}${featureData?.mhTooltip}`;
  }
  // if only premium disc is there, showing autopay only
  else if (!obj?.[promotionConstants.Autopay] && !obj?.[promotionConstants.MHBasic] && obj?.[promotionConstants.MHPremium]) {
    tooltipContents = `${featureData?.toolTipHeading}${featureData?.autopayTooltip}`;
  }
  return tooltipContents;
};

const getWiFiBackupTooltipContent = ({
  featureData,
  isMHDiscountsApplied,
}) => {
  if (!isMHDiscountsApplied) {
    return `${featureData?.toolTipHeading}${featureData?.autopayTooltip}${featureData?.mhNonPremiumTooltip}`;
  }
  return `${featureData?.toolTipHeading}${featureData?.autopayTooltip}`;
};

const getVHILiteTooltipContent = ({ featureData, isMHDiscountsApplied, obj, promotionConstants, isEligibleDiscountsEmpty }) => {
  let vhiLiteToolTip = ``;
  if (isEligibleDiscountsEmpty) {
    vhiLiteToolTip = `${featureData?.toolTipHeading}${featureData?.mhNonPremiumTooltip}${featureData?.autopayTooltip}`;
  } else if (obj?.[promotionConstants.Autopay] && !isMHDiscountsApplied) {
    vhiLiteToolTip = `${featureData?.toolTipHeading}${featureData?.mhNonPremiumTooltip}`;
  } else if (!obj?.[promotionConstants.Autopay] && isMHDiscountsApplied) {
    vhiLiteToolTip = `${featureData?.toolTipHeading}${featureData?.autopayTooltip}`;
  }
  return vhiLiteToolTip;
};

const vhiLiteToolTipCheck = (planName) => isEdgePhase1FFlag() && planName === 'VERIZON HOME INTERNET LITE';

const getBaseTooltipContent = ({
  isEligibleDiscountsEmpty,
  isHomeplan,
  isPremiumThunderPlan,
  featureData,
  displayName,
  planName,
  obj,
  promotionConstants,
  isMHDiscountsApplied,
  eligibleDiscounts,
  propositionName,
  item,
}) => {
  let tooltipContents;

  if (!THUNDER_PLANS.includes(item?.planId)) {
    if (!isLoggedIn() && isEligibleDiscountsEmpty) {
      if(isHomeplan)
        tooltipContents = `${featureData?.emberMHNonPremiumTooltip}<br><br>${featureData?.emberAutopayTooltip}`;
      else if (isPremiumThunderPlan)
        tooltipContents = `${featureData?.emberMHTooltip}<br><br>${featureData?.emberAutopayTooltip}`?.replace('#planName#', displayName);
    }
    const autopayTooltip = getAutopayMHDiscountTooltip({
      obj,
      promotionConstants,
      isMHDiscountsApplied,
      planName,
      featureData,
      displayName,
    });
    if (autopayTooltip) {
      tooltipContents = autopayTooltip;
    } else {
      tooltipContents = getTooltipContentByDiscounts({ eligibleDiscounts, obj, promotionConstants, featureData });
    }
  if (planName === 'WI-FI BACKUP' || propositionName === 'WI-FI BACKUP') {
      tooltipContents = getWiFiBackupTooltipContent({
        featureData,
        isMHDiscountsApplied,
      });
    }
    if (vhiLiteToolTipCheck(planName)) {
      tooltipContents = getVHILiteTooltipContent({
        featureData,
        isMHDiscountsApplied,
        obj,
        promotionConstants,
        isEligibleDiscountsEmpty,
      });
    }
}
  return tooltipContents;
};

export const getTooltipContents = (storeDetails, featureData, item) => {
  const eligibleDiscounts = storeDetails?.progressivePlans?.progressivePlanAPiResponse?.data?.availablePromotions || [];
  const isMHDiscountsApplied = eligibleDiscounts?.includes('MHDiscount');
  const obj = {};
  const mhDiscountDetails = [...eligibleDiscounts, isMHDiscountsApplied && fetchMHDiscounts(item, storeDetails)];
  const planName = item?.displayName?.toUpperCase();
  const propositionName = item?.propositionName?.toUpperCase();
  const displayName = item?.displayName;
  // eslint-disable-next-line no-unused-expressions
  mhDiscountDetails &&
    mhDiscountDetails.forEach((elem) => {
      if (elem !== 'MHDiscount' && elem !== false) {
        obj[elem] = elem;
      }
    });
  const promotionConstants = {
    MHBasic: 'MHBasic',
    Autopay: 'Autopay',
    MHPremium: 'MHPremium',
  };

  const isEligibleDiscountsEmpty = !eligibleDiscounts || eligibleDiscounts?.length===0;
  const isHomeplan = ['5G HOME','LTE HOME'].includes(planName);
  const isPremiumThunderPlan = ['5G HOME PLUS','5G HOME ULTIMATE']?.includes(planName)||
  ['5G HOME PLUS','LTE HOME PLUS','5G HOME ULTIMATE'].includes(propositionName);

  let tooltipContents = getBaseTooltipContent({
    isEligibleDiscountsEmpty,
    isHomeplan,
    isPremiumThunderPlan,
    featureData,
    displayName,
    planName,
    obj,
    promotionConstants,
    isMHDiscountsApplied,
    eligibleDiscounts,
    propositionName,
    item,
  });

  tooltipContents = getThunderTooltipContent({
    tooltipInfo: tooltipContents,
    planId: item?.planId,
    planName,
    propositionName,
    eligibleDiscounts,
    featureData,
    obj,
    promotionConstants,
    isMHDiscountsApplied,
    item,
  });

  return tooltipContents;
};


export const getPriceContent = (value, plan) => {
  const perksPrices = plan?.perksInfoList?.reduce((totalPrice, item) => totalPrice + (item?.price?.discountedPrice || 0), 0);
  return String(value + (perksPrices || 0));
};

export const plansSorting = (planArray) => planArray?.sort((plan1, plan2) => parseInt(plan2?.price?.regularPrice) - parseInt(plan1?.price?.regularPrice));

const showSpecialGiftOverlay = (promo_Choice_Title) => {
  const obj = {
    name: `gift details | ${promo_Choice_Title}`,
    selector: 'specialGiftModal',
  };
  eventDispatcher('openView', obj);
};

export const getPromoBody = (promotions, setShowReviewDetailsOverlay, setReviewDetailsBadgeToolipUrl) =>
  promotions
    ?.map((promo) => {
      if (promo?.choiceOffer) {
        return null;
      }

      const badgeText = promo?.badgeMessages?.find((message) => message?.badgeText && message?.placement === 'ITEM-BODY')?.badgeText;

      if (!badgeText) {
        return null;
      }

      return {
        children: (
          <div
            style={{ display: 'flex', flexDirection: 'column' }}
            data-track={JSON.stringify({
              type: 'link',
              name: `details | ${badgeText}`,
            })}
          >
            <Body bold size="small">
              {badgeText}
            </Body>
            <div>
              <TextLink
                size="small"
                type="standAlone"
                onClick={() => {
                  showSpecialGiftOverlay(badgeText);
                  setShowReviewDetailsOverlay(true);
                  setReviewDetailsBadgeToolipUrl(promo?.badgeToolTipUrl);
                }}
              >
                Details
              </TextLink>
            </div>
          </div>
        ),
      };
    })
    ?.filter((item) => item);

export const getNonChoicePromotions = (promos, selectedPlan, setShowReviewDetailsOverlay, setReviewDetailsBadgeToolipUrl) => {
  if (promos?.length) {
    const footer = { label: { children: 'Included' } };
    const badgeTxt = promos?.[0]?.badgeMessages
      ?.find((item) => item?.placement === 'ITEM-HEADER')
      ?.badgeText?.replace('[xx]', selectedPlan?.displayName);
    const promoTitle = INCLUDED_CHOICE_PROMO_TITLE;
    return {
      backgroundColor: 'white',
      title: {
        children: promoTitle,
      },
      footer,
      cap: {
        children: badgeTxt,
        fillColor: 'black',
      },
      promos: getPromoBody(promos, setShowReviewDetailsOverlay, setReviewDetailsBadgeToolipUrl),
    };
  }
};
const handleSpecialOffersSectionDispatch = ({hasDiscountApplied, isAbandonedCartEmpty, dispatch, pageContextData, saveTheSaleThunderForPlansPageFFlag, setShowSavetheSaleModal, selectedPlan, pzaiTaggingFFlag}) => {
  if (hasDiscountApplied) {
    dispatch({ type: 'ABANDON_DISCOUNT_OFFER_APPILED', value: true });
  }
  if (isAbandonedCartEmpty) {
    dispatch({ type: 'GET_NBX_OFFER_RECOMMENDATION', pageContext: saveTheSaleThunderForPlansPageFFlag ? pageContextData : 'FWA_Plans', FFlag : saveTheSaleThunderForPlansPageFFlag , pzaiflag : pzaiTaggingFFlag });
    if (
      saveTheSaleThunderForPlansPageFFlag && (selectedPlan?.displayName?.toUpperCase() === 'LTE HOME PLUS' ||
      selectedPlan?.displayName?.toUpperCase() === '5G HOME ULTIMATE')
    ) {
      setShowSavetheSaleModal(true);
    }
  }
};

const handleCallbackOnPlanClick = ({reason, dispatch, pageContextData,setShowSavetheSaleModal, selectedPlan, isBarCodeOfferAppliedOnResume, saveTheSaleThunderForPlansPageFFlag, pzaiTaggingFFlag}) => {
  const abandanCartDiscountInfoData = getSession('ABANDON_CART_INFO') ? JSON.parse(getSession('ABANDON_CART_INFO')) : {};
  const hasDiscountApplied = abandanCartDiscountInfoData?.applied;
  const isAbandonedCartEmpty = Object.keys(abandanCartDiscountInfoData).length === 0 && !isBarCodeOfferAppliedOnResume;
  if (reason === 'SUCCESSFULLY_SUBMITTED') {
    handleSpecialOffersSectionDispatch({hasDiscountApplied, isAbandonedCartEmpty, dispatch, pageContextData, saveTheSaleThunderForPlansPageFFlag, setShowSavetheSaleModal, selectedPlan, pzaiTaggingFFlag});
    dispatch({ type: 'ADD_PLAN_API_CALLED', value: true });
  }
  if (reason === 'SUCCESSFULLY_SUBMITTED_ABANDED') {
    dispatch({ type: 'ADD_PLAN_API_CALLED', value: true });
  }
};
export const GetSpecialOffersSection = (
  promos,
  selectedPlan,
  setShowReviewDetailsOverlay,
  setReviewDetailsBadgeToolipUrl,
  setReviewDetailtoolTip,
  specialGiftSelection,
  setShowSavetheSaleModal,
  isfwaUpSellModalFFlag = false,
  saveTheSaleThunderForPlansPageFFlag = false,
  featureFlags,
  additionalProps = {},
  shouldShowSpecialGiftBanner,
  shouldShowBannerFFlag,
  pzaiTaggingFFlag,
) => {
  const dispatch = useDispatch();
  const pageName = getUrlName(window.location.pathname);
  const isBarCodeOfferAppliedOnCart = additionalProps?.isBarCodeOfferAppliedOnCart;
  const isResumeOrder = getSession('isResumeOrder') === 'Y';
  const isBarCodeOfferAppliedOnResume = isBarCodeOfferAppliedOnCart && isResumeOrder;
  const holidayChoiceFFlag = featureFlags?.holidayChoiceFFlag || false;
  const nonChoiceOffer = promos?.filter((item) => !item?.choiceOffer && item?.badgeMessages?.length > 0);
  const handleCallback = (reason, selectButtonId = '', isPromos = false, pageContextData = '', ) => {
    console.log('unused params ', selectButtonId, isPromos);
    handleCallbackOnPlanClick({reason, dispatch, pageContextData, setShowSavetheSaleModal, selectedPlan, isBarCodeOfferAppliedOnResume, saveTheSaleThunderForPlansPageFFlag, pzaiTaggingFFlag});
  };
  const nonChoiceOfferName = holidayChoiceFFlag ? nonChoiceOffer?.[0]?.badgeMessages?.find((item) => item?.placement === 'CHOICE-ACCORD-HEADER-TEXT')?.badgeText : '';
  const choicePromos =  holidayChoiceFFlag ? promos?.filter((item) => item?.badgeMessages?.find((data) => data?.placement === 'ITEM-TITLE')) : promos;
  const promoItems = choicePromos
    ?.map((promo) => {
      const badgeTxt = promo?.badgeMessages?.find((item) => item?.placement === 'ITEM-HEADER')?.badgeText?.replace('[xx]', selectedPlan?.displayName);
      const promoTitle = promo?.badgeMessages?.find((item) => item?.placement === 'ITEM-TITLE')?.badgeText;
      const choiceTileImage = promo?.badgeMessages?.find((item) => item?.placement === 'HEADER-IMAGE')?.badgeText;
      const isstreamlineMinicartNSEFFlag = getIsStreamlineMiniCartFFlag(featureFlags);
      const promoList = promo?.badgeMessages
        ?.filter((prm) => prm?.badgeText !== '' && prm?.placement === 'ITEM-BODY')?.[0]
        ?.badgeText?.split('|')
        ?.map((item) => ({ children: item }));
      const choiceOffer = promo?.choiceOffer;
      const nonChoiceFooter = { label: { children: 'Included' } }; 
      const tooltipUrl = promo?.badgeMessages?.filter((item) => item?.placement === 'ITEM-BODY')?.[0]?.badgeToolTipUrl;
      const overlayContent = promo?.badgeMessages?.filter((item) => item?.placement === 'ITEM-BODY')?.[0]?.badgeToolTip;
      const footer = choiceOffer ? {
        buttonGroup: {
          childWidth: '100%',
          alignment: 'center',
          rowQuantity: {
            desktop: 1,
            mobile: 1,
            tablet: 1,
          },
          data: [
            {
              use: 'primary',
              children: selectedPlan?.selectedSpecialPromo?.sedOfferId === promo?.sedOfferId ? 'Selected' : 'Select',
              disabled: selectedPlan?.selectedSpecialPromo?.sedOfferId === promo?.sedOfferId,
              onClick: () => {
                dispatch({ type: actionTypes.SPECIAL_GIFTSECTION_NOTIFICATION, value: false });
                const addPlanOnSelectPlanSelectionKey = isstreamlineMinicartNSEFFlag || addPlanOnSelectPlanSelection();
                setSession('choiceOfferSelected','Y');
                specialGiftSelection(promo);
                if (addPlanOnSelectPlanSelectionKey && (pageName === 'progressiveplan' || pageName === 'streamlineordering')) {
                  dispatch({
                    type: actionTypes.ADD_PLAN_API,
                    selectSpecialPromo: true,
                    addPlanOnSelectPlanSelectionKey,
                    isfwaUpSellModalFFlag,
                    saveTheSaleThunderForPlansPageFFlag,
                    cb: getCallBack(saveTheSaleThunderForPlansPageFFlag, isfwaUpSellModalFFlag, handleCallback),
                    isPromoButtonSelected: isfwaUpSellModalFFlag,
                    isstreamlineMinicartNSEFFlag,
                    enablePlansPageMiniCartFFlag: isMiniCartFooterEnabled() || false,
                  });
                }
                window.choiceOfferSelected = true;
              },
              'data-track': JSON.stringify({
                type: 'link',
                name: `select | ${promoTitle}`,
              }),
            },
          ],
        },
      } : nonChoiceFooter;
      return {
        backgroundColor: 'white',
        title: {
          children: (
            <div style={{ display: 'flex', alignItems: 'center' }}>
              {holidayChoiceFFlag && <img style={{ height: '50px', width: 'auto' }} src={choiceTileImage} alt={promoTitle} />}
              <Body size="medium" bold>
                {promoTitle}
              </Body>
            </div>
          ),
        },
        details: promoList?.length
          ? {
              textLink: {
                children: 'Review details',
                onClick: () => {
                  showSpecialGiftOverlay(promoTitle);
                  setShowReviewDetailsOverlay(true);
                  setReviewDetailsBadgeToolipUrl(tooltipUrl);
                  setReviewDetailtoolTip(overlayContent);
                },
              },
              list: promoList,
            }
          : {},
        footer,
        ...(!holidayChoiceFFlag && {
          cap: {
            children: badgeTxt,
            fillColor: 'red',
          },
        }),
      };
    });

  const specialOffers = {
    id: 'specialGiftSection',
    notification: {
      title: 'Based on your plan selection, please select a new gift',
      disableFocus: (additionalProps?.isDisableFocus || getSession('choiceOfferSelected')==='Y') || false,
      id: 'specialGiftNotificationID',
    },
    title: {
      id: 'specialOfferSection',
      children: 'A special gift, on us',
    },
    subtitle: {
      children: getSpecialGiftSubtitle(shouldShowSpecialGiftBanner, shouldShowBannerFFlag, nonChoiceOfferName),
    },
    items: promoItems,
  };

  return isSpecialOfferSectionEnable(choicePromos) ? specialOffers : {};
};

const specialGiftNotificationProps = {
  type: 'error',
  title: 'Special gift selection is required',
  subtitle: 'You must select a special gift to continue your order',
  id: 'specialGiftNotificationID',
  hideCloseButton: true,
};
export const getSpecialGiftSubtitle = (shouldShowSpecialGiftBanner, shouldShowBannerFFlag, nonChoiceOfferName) => (
  <SubTitleWrapper>
    <RequiredWrapper>Required</RequiredWrapper> - {nonChoiceOfferName || 'Choose one gift, included with your plan.'}
    {shouldShowSpecialGiftBanner && shouldShowBannerFFlag &&  window.location.pathname?.includes('progressiveplan') && (
      <div style={{ marginTop: '20px' }}>
        <Notification {...specialGiftNotificationProps} />
      </div>
    )}
  </SubTitleWrapper>
);

export const isSpecialOfferSectionEnable = (promos) => promos?.some((promo) => promo?.choiceOffer);

export const clearAbandonedCart = (dispatch, isfwaUpSellModalFFlag) => {
  if (isfwaUpSellModalFFlag) {
    const abandanCartDiscountInfoData =  getSession('ABANDON_CART_INFO') ? JSON.parse(getSession('ABANDON_CART_INFO')) : {};
    if (Object.keys(abandanCartDiscountInfoData).length > 0) {
      sessionStorage.removeItem('ABANDON_CART_INFO');
      dispatch({ type: 'UPDATE_NBX_OFFER_RECOMMENDATION', response: {} });
      dispatch({ type: 'UPDATE_NBX_OFFER_RECOMMENDATION_EC', response: {} });
    }
  }
};
export const getWelcomeBannerConditions = (isLoyaltyCust, isNseFlowToAAL, isWelcomeBannerShown) =>
  !isLoyaltyCust && !isNseFlowToAAL && !isWelcomeBannerShown;

export const onPlanChangeSessionClear = (dispatch, isfwaUpSellModalFFlag) => {
  if (isfwaUpSellModalFFlag) {
    const abandanCartDiscountInfoData = getSession('ABANDON_CART_INFO') ? JSON.parse(getSession('ABANDON_CART_INFO')) : {};
    if (Object.keys(abandanCartDiscountInfoData).length > 0 && !abandanCartDiscountInfoData?.applied) {
      clearAbandonedCart(dispatch, isfwaUpSellModalFFlag);
    }
  }
};

export const hasChoiceOffer = (promotions) => promotions && promotions?.some((promo) => promo.choiceOffer === true)
export const getCallBack = (saveTheSaleThunderForPlansPageFFlag, isfwaUpSellModalFFlag, handleCallback) => (saveTheSaleThunderForPlansPageFFlag || isfwaUpSellModalFFlag) && handleCallback;

export const commonFooter = (thunderStaticContent, MhFLStaticContent, mhFLPromoId) => {
  if (isFLDiscountFFlag() && mhFLPromoId) {
    return (
      <div>
        <Micro color="#6F7171">
          {isLteOnlyQualified() || (isEdgePhase1FFlag() && isVHILiteQualified()) ? thunderStaticContent?.discountLTEFooter : thunderStaticContent?.discountFooter}
          <Tooltip size="small">{renderHTML(MhFLStaticContent?.discountFooterTooltip || '')}</Tooltip>
        </Micro>
        <br />
        <div className="flex">
          <Micro id="mhFooter">
            **<>&nbsp;&nbsp;</>
          </Micro>
          <Micro id="mhFooter">{thunderStaticContent?.priceGuaranteeFooter}</Micro>
        </div>
        <br />
      </div>
    );
  }
  return (
    <div>
      <Micro color="#6F7171">
        {isLteOnlyQualified() || (isEdgePhase1FFlag() && isVHILiteQualified()) ? thunderStaticContent?.discountLTEFooter : thunderStaticContent?.discountFooter}
        <Tooltip size="small">{parse(thunderStaticContent?.discountFooterTooltip || '')}</Tooltip>
      </Micro>
      <br />
      <div className="flex">
        <Micro id="thunderFooter">
          **<>&nbsp;&nbsp;</>
        </Micro>
        <Micro id="thunderFooter">{thunderStaticContent?.priceGuaranteeFooter}</Micro>
      </div>
      <br />
    </div>
  );
};